import React from 'react'
import PanelHead from '../../../Panel/PanelHead'
import PanelBody from '../../../Panel/PanelBody'
import TelegramGroupTable from './TelegramGroupTable'

const TelegramGroupList = () => {
  return (
    <div>
      <PanelHead title='Telegram Groups'/>
      <PanelBody content={<TelegramGroupTable/>} />
      </div>
  )
}

export default TelegramGroupList

